import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { FONT_FAMILY } from '../../../constants/typography';

const LogoutDialog = ({ open, onClose, onLogout }) => {
  const handleConfirmLogout = () => {
    onClose();
    // Clear localStorage and remove session from DB
    localStorage.clear();
    onLogout(true); // true = remove session from DB
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: '#2a2a2a',
          color: '#fff',
          borderRadius: 2,
          border: '1px solid rgba(255, 255, 255, 0.12)',
        }
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        }
      }}
    >
      <DialogTitle sx={{ color: '#fff', fontFamily: FONT_FAMILY, fontSize: 20, fontWeight: 600, pb: 1 }}>
        Logout
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Typography sx={{ color: 'rgba(255, 255, 255, 0.9)', fontFamily: FONT_FAMILY, fontSize: 14 }}>
          Are you sure you want to logout?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button
          onClick={onClose}
          sx={{
            color: '#fff',
            fontFamily: FONT_FAMILY,
            textTransform: 'none',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirmLogout}
          variant="contained"
          sx={{
            backgroundColor: '#FEEC67',
            color: '#121212',
            fontFamily: FONT_FAMILY,
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#ffe15a',
            },
          }}
        >
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
};

LogoutDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
};

export default LogoutDialog;
